import DatePicker from "react-datepicker"
import { DATE_FORMAT } from "../../../utils/dateFormat"

interface DateInputProps {
  selected: Date | null
  onChange: (date: Date | null) => void
  dateFormat?: string
  className?: string
}

export default function DateInput({
  selected,
  onChange,
  dateFormat = DATE_FORMAT,
  className = "box-form-input",
}: DateInputProps) {
  return <DatePicker className={className} selected={selected} dateFormat={dateFormat} onChange={onChange} />
}